export default __webpack_public_path__ + "static/media/@master25o0.319bcda3.jpg";